import React, { useState, useEffect } from 'react';
import { FaUser, FaProjectDiagram, FaListAlt,  FaRulerCombined,  FaInfoCircle } from 'react-icons/fa';
import Dashboard from '../../Admin/Dashboard';
import Weather from '../../Admin/Weather';
import IAProfiling from '../../Admin/ProfileSlide';
import IATraining from '../../Admin/TrainingSlide';
import styled from 'styled-components';
import bg1 from '../../Assets/bg/bg5.jpg';
import bg2 from '../../Assets/bg/Pilar.jpg';
import bg3 from '../../Assets/bg/SanMiguel.jpg';
import bg4 from '../../Assets/bg/Capayas.jpg';
import bg5 from '../../Assets/bg/Ubay.jpg';
import useIAProfileCounts from '../../Hooks/IAprofileHooks/useCountsIaProfile';
import useIATrainingCounts from '../../Hooks/IAtrainingHooks/useCountsIaTraining';
import useNISCounts from '../../Hooks/NisHooks/useCountsNIS';


const HomeBohol = ({darkMode}) => {
  const [backgroundIndex, setBackgroundIndex] = useState(0);
  const [showIAProfiling, setShowIAProfiling] = useState(false);
  const [showIATraining, setShowIATraining] = useState(false);
  const [showIMTContract, setShowIMTContract] = useState(false);
  const [showInfoModal, setShowInfoModal] = useState(false);
  const [infoTitle, setInfoTitle] = useState('');
  const [infoDescription, setInfoDescription] = useState('');
  const [selectedFarmer, setSelectedFarmer] = useState(null);


  const handleSelectFarmer = (farmer) => {
    setSelectedFarmer(farmer);
  };
  const { counts: profileCounts} = useIAProfileCounts(); 
  const { counts: trainingCounts} = useIATrainingCounts(); 
  const { counts: nisCounts} = useNISCounts();

  const images = [bg1, bg2, bg3, bg4, bg5];

  const [isSidebarExpanded] = useState(false); 

  const profileData = [
    { name: 'IA Profile', value: profileCounts.iaProfile },
    { name: 'IA Training', value: trainingCounts.iaTraining },
    { name: 'NIS', value: nisCounts.nis },
    
  ];
  
  useEffect(() => {
    const intervalId = setInterval(() => {
      setBackgroundIndex((prevIndex) => (prevIndex + 1) % images.length);
    }, 5000);

    return () => clearInterval(intervalId);
  }, []);

  const handleBarClick = (data) => {
 
    setShowIAProfiling(false);
    setShowIATraining(false);
    setShowIMTContract(false);
  
    switch (data.name) {
      case 'IA Profile':
        setShowIAProfiling(true);
        break;
      case 'IA Training':
        setShowIATraining(true);
        break;
      case 'IMT Contract':
        setShowIMTContract(true);
        break;
      default:
        break;
    }
  };
  
  const getIcon = (item) => {
    switch (item) {
      case 'Farmers':
        return <FaUser color="#2e7d32" size={24} />;
      case 'Projects':
        return <FaProjectDiagram color="#1976d2" size={24} />;
      case 'Masterlist':
        return <FaListAlt color="#f57c00" size={24} />;
      case 'Land Area':
        return <FaRulerCombined color="#00838f" size={24} />;
      
      default:
        return null;
    }
  };
  
  const formItems = [
    'Farmers',
    'Projects',
    'Masterlist',
    'Land Area' 
  ];
  
  const handleInfoClick = (item) => {
    switch (item) {
      case 'Farmers':
        setInfoTitle('Farmers Count Explained');
        setInfoDescription('The Farmers count you see on your dashboard is the number of farmers ongoing for May. This reflects only those actively participating or registered for current initiatives.');
        break;
      case 'Projects':
        setInfoTitle('Projects Count Explained');
        setInfoDescription('Projects refers to ongoing or completed initiatives under the irrigation authority. It includes infrastructure, training, and support efforts.');
        break;
      case 'Masterlist':
        setInfoTitle('Masterlist Explained');
        setInfoDescription('Masterlist includes all registered farmers, their affiliations, and land data compiled by the system.');
        break;
      case 'Land Area':
        setInfoTitle('Land Area Explained');
        setInfoDescription('Land Area refers to the total irrigated or planned-to-irrigate hectares monitored under your IA jurisdiction.');
        break;
      default:
        setInfoTitle('');
        setInfoDescription('');
    }
    setShowInfoModal(true);
  };

  
  return (
    <Container isExpanded={isSidebarExpanded}>
      <FormsSection>
      {formItems.map((item, index) => (
  <FormCard key={index} onClick={() => console.log(`${item} clicked`)}>
  <LeftSection>
   {getIcon(item)}
   <Label>{item}</Label>
   </LeftSection>
   <Count>0</Count>
  <InfoIcon onClick={(e) => {
   e.stopPropagation();
   handleInfoClick(item);
    }} />
  </FormCard>

    ))}

  </FormsSection>
  <ContentWrapper isExpanded={isSidebarExpanded}>
     

  <MainSection>
      <Dashboard profileData={profileData} bgImage={images[backgroundIndex]} onBarClick={handleBarClick} />
     
        

  <div style={{ display: 'flex', flexDirection: 'column', gap: '20px' }}>
    <WeatherWrapper>
      <Weather />
    </WeatherWrapper>

  </div>
   
  </MainSection>
      
  </ContentWrapper>


      {showIAProfiling && <IAProfiling setShowIAProfiling={setShowIAProfiling} />}
      {showIATraining && <IATraining setShowIATraining={setShowIATraining} />}
      {showIMTContract && <div>IMT Component Placeholder</div>} 

      {showInfoModal && (
    <ModalOverlay onClick={() => setShowInfoModal(false)}>
      <ModalContent onClick={(e) => e.stopPropagation()}>
        <h2>{infoTitle}</h2>
        <p>{infoDescription}</p>
        <CloseButton onClick={() => setShowInfoModal(false)}>OK</CloseButton>
      </ModalContent>
    </ModalOverlay>
  )}

    </Container>
  );
};

export default HomeBohol;

const Container = styled.div`
  display: flex;
  margin-left: ${({ isExpanded }) => (isExpanded ? '1110px' : '0px')};
  flex-direction: column;
  height: 100vh;
  overflow-y: auto;
`;

const ContentWrapper = styled.div`
  flex-grow: 1;
  display: flex;
  justify-content: center;
  
  gap: 60px;
  padding: 10px;
  margin-top: -45px;
  margin-left:  0px;
`;

const MainSection = styled.div`
  display: flex;
  flex-grow: 1;               
  justify-content: space-between;
  align-items: flex-start;     /* Align items to the top (optional) */
  width: 100%;
  gap: 20px;  
  
   @media (max-width: 768px) {
    grid-template-columns: 1fr; 
  }
`;

const WeatherWrapper = styled.div`
  width: 300px;   /* Fixed width for the Weather component */
  min-width: 250px; /* Ensures the weather widget doesn't shrink too much */
`;

const FarmerSection = styled.div`
  display: flex;
  flex-direction: column;
  flex-grow: 1;
  gap: 20px;
`;


const FormsSection = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  grid-template-columns: repeat(auto-fit, minmax(250px, 1fr));
  gap: 15px;
  padding: 5px;

  border-radius: 10px;
  margin: 50px 15px;
  flex-wrap: wrap; 
`;

const FormCard = styled.div`
  position: relative;
  display: flex;
  justify-content: space-between;
  align-items: center;
  width: 300px;
  height: 70px;
  padding: 0 20px;
  background: #f5f5f5;
  border-radius: 10px;
  font-weight: 500;
  color: #333;
  cursor: pointer;
  box-shadow: 0 2px 8px rgba(0,0,0,0.1);
  transition: transform 0.3s ease;

  &:hover {
    transform: translateY(-5px);
    background: #e0f2f1;
  }
`;

const LeftSection = styled.div`
  display: flex;
  align-items: center;
  gap: 10px;
`;

const Label = styled.span`
  font-size: 1rem;
`;

const Count = styled.div`
  font-size: 1.2rem;
  font-weight: bold;
  margin-right: 20px;
  color: #4caf50;
`;

const InfoIcon = styled(FaInfoCircle)`
  position: absolute;
  top: 8px;
  right: 8px;
  color: #999;
  font-size: 16px;
  cursor: pointer;

  &:hover {
    color: #000;
  }
`;


const ModalOverlay = styled.div`
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: rgba(0,0,0,0.5);
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 999;
`;

const ModalContent = styled.div`
 background-color: ${({ darkMode }) => (darkMode ? 'rgb(42, 48, 42)' : '#f2f2f2')};
  padding: 10px;
  color: #333;
  border-radius: 15px;
  max-width: 500px;
  width: 100%;
  text-align: center;
  animation: fadeInModal 0.3s ease;

  @keyframes fadeInModal {
    from {
      opacity: 0;
      transform: scale(0.95);
    }
    to {
      opacity: 1;
      transform: scale(1);
    }
  }
`;

const CloseButton = styled.button`
  margin-top: 20px;
  background: #4caf50;
  border: none;
  color: white;
  padding: 10px 25px;
  font-size: 1rem;
  border-radius: 8px;
  cursor: pointer;
  transition: background 0.3s;

  &:hover {
    background: #388e3c;
  }
`;
